import { Entity, FieldType, PersistenceType } from 'gossamer-unified';

export interface PushNotificationStatsRow {
  hour: string;
  notification_type: string;
  status: string;
  count: number;
  avg_response_time_ms: number | null;
  max_response_time_ms: number | null;
  min_response_time_ms: number | null;
}

export const PushNotificationStats: Entity<PushNotificationStatsRow> = {
  id: 'PushNotificationStats',
  title: 'Push Notification Stats',
  service: 'main',
  rowLabel: (row: PushNotificationStatsRow) =>
    `${new Date(row.hour).toLocaleString()} - ${row.notification_type} (${row.status})`,
  primaryKeyFields: ['hour', 'notification_type', 'status'],
  source: {
    tableName: 'public.push_notification_stats',
  },
  security: [{ role: 'staff', action: 'read', access: 'all' }],
  defaultSort: [['hour', 'DESC']],
  defaultFilters: [],
  fields: {
    hour: {
      seq: 5,
      type: FieldType.Datetime,
      label: 'Hour',
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
    },
    notification_type: {
      seq: 10,
      type: FieldType.Options,
      label: 'Type',
      listColumn: true,
      options: [
        { id: 'message', label: 'Message' },
        { id: 'test', label: 'Test' },
        { id: 'system', label: 'System' },
        { id: 'reminder', label: 'Reminder' },
        { id: 'alert', label: 'Alert' },
      ],
      persistence: PersistenceType.BackEndManaged,
    },
    status: {
      seq: 15,
      type: FieldType.Options,
      label: 'Status',
      listColumn: true,
      options: [
        { id: 'sent', label: 'Sent' },
        { id: 'failed', label: 'Failed' },
        { id: 'expired', label: 'Expired' },
      ],
      persistence: PersistenceType.BackEndManaged,
    },
    count: {
      seq: 20,
      type: FieldType.Integer,
      label: 'Count',
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
    },
    avg_response_time_ms: {
      seq: 25,
      type: FieldType.Integer,
      label: 'Avg Response (ms)',
      listColumn: true,
      persistence: PersistenceType.BackEndManaged,
    },
    max_response_time_ms: {
      seq: 30,
      type: FieldType.Integer,
      label: 'Max Response (ms)',
      persistence: PersistenceType.BackEndManaged,
    },
    min_response_time_ms: {
      seq: 35,
      type: FieldType.Integer,
      label: 'Min Response (ms)',
      persistence: PersistenceType.BackEndManaged,
    },
  },
};
